<template>
    <div class="index-exhibition">
        <div class="index-exhibition-title">
            <p class="index-exhibition-title-zh" ref="exhibitionZh" :class="{active:isActive}">{{$t('navBar.exhibition')}}</p>
            <p class="index-exhibition-title-en" ref="exhibitionEn" :class="{active:isActive}" v-show="$i18n.locale==='zh'">CASE PRESENTATION</p>
        </div>
        <div class="index-exhibition-content">
            <div class="kaKa">
                <div class="kaKa-img kaKaFloat" ref="kaKaImg" :class="{active:isActive}">
                    <img onclick="return false" class="kaKa-img-float" src="../../assets/phonekaka1.png" alt="">
                    <img onclick="return false" src="../../assets/phonekaka2.png" alt="">
                </div>
                <div class="kaKa-des" ref="kaKaDes" :class="{active:isActive}">
                    <p class="kaKa-des-title">
                        咔咔城堡
                    </p>
                    <p class="kaKa-des-content">
                        "赛德部落技术团队全力打造物联网+的新型租赁模式，助力咔咔城堡为孩子带来美好童年。
                        App下单------>自提柜取货------->自提柜归还———>工作人员取货。
                    </p>
                    <a @click="toExhibitions" style="text-decoration: none">
                        <x-button type="primary" style="background-color:#0a63fc;border: #0a63fc">{{ $t('exhibition.more')}}</x-button>
                    </a>
                </div>
            </div>
            <div class="linYun">
                <div class="linYun-des" ref="LinYunDes" :class="{active:isActive}">
                    <p class="linYun-des-title">
                        邻云管家
                    </p>
                    <p class="linYun-des-content">
                        赛德部落技术团队打造全方位物业解决方案，全面切入物业管理行业痛点，包含智能通行，智慧物业，智能安防，满足业主多种应用场景，提升物业服务质量，赛德部落与邻云科技一同前行。
                    </p>
                    <a @click="toExhibitions" style="text-decoration: none">
                        <x-button type="primary" style="background-color:#0a63fc;border: #0a63fc">{{ $t('exhibition.more')}}</x-button>
                    </a>
                </div>
                <div class="linYun-img linYunFloat" ref="LinYunImg" :class="{active:isActive}">
                    <img onclick="return false" class="linYun-img-float" src="../../assets/phonelinyun.png" alt="">
                    <img onclick="return false" class="linYun-img-leftFloat" src="../../assets/tabletlinyun.png" alt="">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Button from '../../components/button/button'
    import {isPC} from '../../utils/methods'
    import {destroyEventListener} from '../../utils/lazyActive'
    export default {
        name: "exhibition",
        components:{
            'x-button': Button,
        },
        data(){
          return {
              isActive:false,
              name:'exhibition'
          }
        },
        mounted(){
            window.requestAnimationFrame(()=>{
                if(this.$route.fullPath==='/#exhibition'&&!this.isActive) {
                    setTimeout(() => {
                        this.isActive = true
                    }, 100)
                }
            })
        },
        methods:{
            toExhibitions(){
                destroyEventListener()
                this.$router.push({path:'/exhibitions'})
            },
        },
        watch:{
            '$route.fullPath'(){
                if(this.$route.fullPath==='/#exhibition'&&!this.isActive) {
                    setTimeout(() => {
                        this.isActive = true
                    }, 100)
                }
            }
        }
    }
</script>

<style scoped lang="scss" src="./exhibition.scss"></style>
